import * as React from 'react'
import { useEffect, useState } from 'react';
import { EditorState, convertToRaw, ContentState } from 'draft-js'
import * as draftToHtml from 'draftjs-to-html'
import htmlToDraft from 'html-to-draftjs'
import RichTextEditorComponent from './RichTextEditorComponent';

export interface LabelTextComponentProps {
    labelText: string,
    changeLabelText: Function,
    userIsOwner: boolean,
    limitedEditing: boolean,
    selectedPartIndex: number
}

const LabelTextComponent = (props: LabelTextComponentProps) => {

    const partTextToBlocks = htmlToDraft(props.labelText ?? "")
    const [editorState, setEditorState] = useState(
        () => EditorState.createWithContent(ContentState.createFromBlockArray(partTextToBlocks.contentBlocks, partTextToBlocks.entityMap)),
    )

    useEffect(() => {
        var blocks = htmlToDraft(props.labelText ?? "")
        setEditorState(() => EditorState.createWithContent(ContentState.createFromBlockArray(blocks.contentBlocks, blocks.entityMap)),)
    }, [props.selectedPartIndex])

    const changeEditor = editorState => {
        const rawContentState = convertToRaw(editorState.getCurrentContent())
        let markup: string = draftToHtml(
            rawContentState,
        )
        while (markup.includes("<p>")) {
            markup = markup.replace("<p>", "")
        }
        while (markup.includes("</p>")) {
            markup = markup.replace("</p>", "")
        }
        if (markup.length <= 200) {
            props.changeLabelText(markup)
            setEditorState(editorState)
        }
    }

    return (
        <div className="row my-2">
            <div className="col">
                <RichTextEditorComponent
                    editorState={editorState}
                    changeEditor={changeEditor}
                    placeholder=""
                    editorStyle={"calcpad-rte-labeleditor"}
                    editorDisabledStyle={"calcpad-rte-labeldisabled"}
                    maxCharacters={25}
                    showSymbolDropdown={false}
                    readOnly={!props.userIsOwner}
                    toolbar={{
                        options: ['inline', 'colorPicker', 'remove'],
                        inline: {
                            options: ['bold', 'superscript', 'subscript'],
                            bold: { className: !props.userIsOwner ? "calcpad-rte-option-disabled" : "calcpad-rte-option" },
                            superscript: { className: !props.userIsOwner ? "calcpad-rte-option-disabled" : "calcpad-rte-option" },
                            subscript: { className: !props.userIsOwner ? "calcpad-rte-option-disabled" : "calcpad-rte-option" },
                        },
                        colorPicker: {
                            className: !props.userIsOwner ? "calcpad-rte-option-disabled" : "calcpad-rte-option",
                            popupClassName: !props.userIsOwner ? "calcpad-rte-option-disabled" : "calcpad-rte-option"
                        },
                        remove: {
                            className: !props.userIsOwner ? "calcpad-rte-option-disabled" : "calcpad-rte-option",
                        }
                    }}
                />
            </div>

        </div>
    )
}



export default LabelTextComponent;